import React from 'react';

/** DateTimePicker stub — use native <input type="date"> in a later PWA form pass. */
export default function DateTimePicker() {
  return null;
}
